import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../utils/api";
import paths from "../utils/paths";

export const useHistoryLogs = (table, id) => {
    return useQuery({
        queryKey: ['historyLogs', table, id],
        queryFn: async () => {
            try {
                const response = await axiosInstance.get(`${paths.historyLogs}?table=${table}&id=${id}`);
                return response.data?.data;
            } catch (error) {
                // Extract error message from response
                const errorMessage = error.response?.data?.message || error.message || "Failed to load history logs";
                throw new Error(errorMessage);
            }
        },
        staleTime: 0,
        cacheTime: 0,
        enabled: !!table && !!id, // Only run query when both table and id are provided
    });
};

export const useHistoryLogsFilters = () => {
    return useQuery({
        queryKey: ['historyLogsFilters'],
        queryFn: async () => {
            const response = await axiosInstance.get(paths.historyLogsFilters);
            return response.data?.filters;
        },
    });
};
